module.exports = __webpack_public_path__ + "static/case-hp-06-613d6cdbd67c8c33283bf1d856aa9a97.gif";